import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { User } from '../models/user';
import { UserService } from '../services/user.service';
import { ThemeService } from '../services/theme.service';
import { TouchScrollLockService } from '../services/touch-scroll-lock.service';
import { SpacesSwitcherService } from '../services/spaces-switcher.service';

@UntilDestroy()
@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
})
export class SwitcherComponent implements AfterViewInit, OnInit, OnDestroy {
  user?: User;
  institutionLogo: string | undefined = undefined;
  cleanupTouchScrollPrevention: () => void = () => {};

  /** Gates switcher-only chrome. Re-emits once the flags finish loading. */
  readonly isSpacesSwitcherEnabled$ = this.spacesSwitcherService.isEnabled$;

  constructor(
    public userService: UserService,
    private themeService: ThemeService,
    private touchScrollLockService: TouchScrollLockService,
    private spacesSwitcherService: SpacesSwitcherService,
  ) {}

  ngAfterViewInit(): void {
    const switcher = document.getElementById('app-switcher') as HTMLElement;
    this.cleanupTouchScrollPrevention =
      this.touchScrollLockService.registerTouchScrollPrevention(switcher);
  }

  ngOnInit(): void {
    this.userService.user.pipe(untilDestroyed(this)).subscribe({
      next: (res) => {
        this.user = res?.user;
      },
    });

    this.themeService.squareLogo$.pipe(untilDestroyed(this)).subscribe((logo) => {
      this.institutionLogo = logo;
    });
  }

  ngOnDestroy(): void {
    this.cleanupTouchScrollPrevention();
  }
}
